import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup } from "reactstrap";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InvoiceVerificationList from "../../components/FleetManager/InvoiceVerification/InvoiceVerificationList";
import InvoiceVerificationDetail from "../../components/FleetManager/InvoiceVerification/InvoiceVerificationDetail";
import "./FleetManager.css";
import FleetManagerService from "../../services/FleetManagerService";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import HODashboardService from "../../services/HODashaboardService";
import StorageService from "../../services/Storage";
import { Roles } from "../../constants/constant.role";

class InvoiceVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToDashboard: false,
      userRole: StorageService.getUserDetail().type,
      Dashboard: null,
      invoiceVerificationData: {
        pageCount: 1,
        page: 1,
      },
      selectedInvoiceForVerification: {},
      isLoading: false,
      yearOptions: [],
      year: null,
      year_name_value: {},
    };
  }

  componentWillMount() {
    // this.getPendingOfftake(1);
  }

  componentDidMount = () => {
    const searchParam = this.props.location.search;
    if (searchParam) {
      const keys = searchParam.split("?");
      const nameString = keys[1];
      const id = nameString.split("=");
      const Dashboard = id[1];

      this.setState({ Dashboard });
    }
  };

  getPendingOfftake = async (qPage = 1, from = "other", year) => {
    let { invoiceVerificationData, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const q = {
        page: qPage,
        pagesize: 10,
        status: "pending",
        downloadReport: false,
        year: year,
      };

      const { data } = await FleetManagerService.getPendingOfftake(q);
      isLoading = false;
      if (data) {
        invoiceVerificationData = data.data;

        if (
          from === "updateState" &&
          !invoiceVerificationData.offtake_entries.length
        ) {
          this.goToDashboard();
        }
        invoiceVerificationData.pageCount =
          Math.trunc(invoiceVerificationData.total_count / 10) + 1;
        invoiceVerificationData.page = qPage;
      }
      this.setState({ invoiceVerificationData, isLoading });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
      console.log(error);
    }
  };

  getPendingOfftakeById = async (item) => {
    let { selectedInvoiceForVerification, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const obj = {
        id: item.uuid,
      };

      const { data } = await FleetManagerService.getOfftakeEntryById(obj);
      isLoading = false;

      if (data.data && data.data[0]) {
        selectedInvoiceForVerification = data.data[0];
      }
      this.setState({ selectedInvoiceForVerification, isLoading });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
      console.log(error);
    }
  };

  goToPointDashboard = () => {
    let { redirectToDashboard } = this.state;
    redirectToDashboard = true;
    this.setState({ redirectToDashboard });
  };

  updateState = (params) => {
    this.setState({ ...params });
    this.getPendingOfftake(1, "updateState");
  };

  goToDashboard = () => {
    this.props.history.push("/dashboard");
  };

  componentDidMount = () => {
    this.filterAPI();
  };

  filterAPI = () => {
    const { year } = this.state;

    let filter = {
      y: year ? year : null,
    };
    this.setState({ isLoader: true });
    HODashboardService.filterAPI(filter)
      .then((res) => {
        if (res.data.data) {
          this.setState({ isLoader: false });

          this.setState(
            {
              yearOptions: res.data.data.year ? res.data.data.year : [],
            },
            () => {
              if (
                !this.state.year &&
                this.state.yearOptions &&
                this.state.yearOptions[0]
              ) {
                this.setState(
                  {
                    // year: this.state.yearOptions[0].value,
                    year_name_value: this.state.yearOptions[0],
                  },
                  () => {
                    this.getPendingOfftake(
                      1,
                      "",
                      this.state.year ? this.state.year : null
                    );
                  }
                );
              }
              //  else {
              //   this.getPendingOfftake(
              //     1,
              //     "",
              //     this.state.year ? this.state.year : null
              //   );
              // }
            }
          );
        }
      })
      .catch((err) => {
        this.setState({ isLoader: false });
        console.log("err", err);
      });
  };

  onChangeYear = (e) => {
    if (e.target.value === "All") {
      e.target.value = null;
    }
    this.setState(
      {
        year: e && e.target && e.target.value,
      },
      () => {
        // this.filterAPI();
        let { yearOptions, year_name_value, year } = this.state;
        if (year) {
          year_name_value = yearOptions.filter((x) => x.value == year);
        }
        if (year_name_value) {
          year_name_value =
            year_name_value && year_name_value[0]
              ? year_name_value[0]
              : year_name_value;
          this.setState({ year_name_value });
          this.getPendingOfftake(
            1,
            "",
            this.state.year ? this.state.year : null
          );
        }
      }
    );
  };

  render() {
    const {
      isLoading,
      invoiceVerificationData,
      selectedInvoiceForVerification,
      redirectToDashboard,
      userRole,
    } = this.state;
    return (
      <div>
        {isLoading && <CustomSpinner />}
        {redirectToDashboard && <Redirect to="/" />}

        <Row
          style={{
            marginBottom: this.state.yearOptions.length > 1 ? "-17px" : "-6px",
            marginTop: "-10px",
          }}
        >
          <Col md="4" xs="12">
            <div style={{ display: "flex" }}>
              <span
                onClick={
                  this.state.Dashboard
                    ? this.goToDashboard
                    : this.goToPointDashboard
                }
                className="select-vehicle-label"
                style={{ color: "#545cd8", cursor: "pointer" }}
              >
                {!this.state.Dashboard &&
                  userRole === Roles.ZONAL_FLEET_MANAGER_ROLE &&
                  "Point"}{" "}
                Dashboard
              </span>
              &nbsp;&nbsp;
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{
                  fontSize: "26px",
                  cursor: "pointer",
                  marginTop: "-5px",
                }}
                color="#fdbb1f"
              />
              &nbsp;&nbsp;
              <span className="Offtake-Entry---Invo">Invoice Verification</span>
            </div>
          </Col>
          {this.state.yearOptions.length > 1 && (
            <Col md="2" xs="12">
              <FormGroup>
                <select
                  name="month"
                  className="form-control cursor-pointer"
                  value={this.state.year}
                  style={{
                    fontSize: "13px",
                    width: "110px",
                    color: "#6e777f",
                    marginLeft: "auto",
                  }}
                  onChange={(e) => {
                    this.onChangeYear(e);
                  }}
                >
                  <option value={null} selected>
                    All
                  </option>
                  {this.state.yearOptions.map((item) => (
                    <option value={item.value}>{item.name}</option>
                  ))}
                </select>
              </FormGroup>
            </Col>
          )}
        </Row>

        {this.state.year && (
          <div className="showingText">
            Financial Year{" "}
            {this.state.year_name_value && this.state.year_name_value.name}.
          </div>
        )}

        {(invoiceVerificationData.offtake_entries || []).length > 0 && (
          <Row style={{ marginTop: "10px" }}>
            <Col>
              <Card>
                <CardBody>
                  <InvoiceVerificationList
                    invoiceVerificationData={invoiceVerificationData}
                    getPendingOfftake={this.getPendingOfftake}
                    updateState={this.updateState}
                    getPendingOfftakeById={this.getPendingOfftakeById}
                  />
                </CardBody>
              </Card>
            </Col>

            <Col>
              <Card>
                <CardBody>
                  <InvoiceVerificationDetail
                    selectedInvoiceForVerification={
                      selectedInvoiceForVerification
                    }
                    updateState={this.updateState}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {(invoiceVerificationData.offtake_entries || []).length === 0 && (
          <Row className="c-top-15">
            <Col>
              <Card>
                <CardBody style={{ color: "grey", fontSize: "18px" }}>
                  <center>No records found</center>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default InvoiceVerification;
